import script from "./sharingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./sharingPage.vue?vue&type=script&setup=true&lang=js"

import "./sharingPage.vue?vue&type=style&index=0&id=1db44d49&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db44d49"]])

export default __exports__